module.exports = __webpack_public_path__ + "img/banner-11.de2ea3a9.jpg";